'use client';

import { type FC } from 'react';

export const SearchResultPageEffects: FC = () => null;
